/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FileDto } from '../../models/file-dto';
import { PageInfoDto } from '../../models/page-info-dto';

export interface StorageControllerSearchOffset$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;
  clientWorkspaceId?: string;

/**
 * 이미지 여부 (true: 이미지, false: 비디오)
 */
  isImage?: boolean;
}

export function storageControllerSearchOffset(http: HttpClient, rootUrl: string, params: StorageControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items'?: Array<FileDto>;
'pageInfo'?: PageInfoDto;
}>> {
  const rb = new RequestBuilder(rootUrl, storageControllerSearchOffset.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('clientWorkspaceId', params.clientWorkspaceId, {});
    rb.query('isImage', params.isImage, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'items'?: Array<FileDto>;
      'pageInfo'?: PageInfoDto;
      }>;
    })
  );
}

storageControllerSearchOffset.PATH = '/api/storage/search/offset';
